import { Testimonial } from "../../types";

type TestimonialCardProps = { testimonial: Testimonial };

export function TestimonialCard({ testimonial }: TestimonialCardProps) {
  return (
    <article className="testimonial-card">
      <p>{testimonial.quote}</p>
      <strong>{testimonial.name}</strong>
      <span>{testimonial.context}</span>
    </article>
  );
}
